export enum FieldType {
    Input = 'custom-input',
    Textarea = 'textarea',
    Checkbox = 'checkbox',
    MultiCheckbox = 'multicheckbox',
    Select = 'custom-select',
    Numeric = 'numeric-input',
    ColorPicker = 'color-picker',
    DatePicker = 'datepicker',
    TimePicker = 'timepicker',
    DateTimePicker = 'datetimepicker',
    Combobox = 'combobox',
    CustomCombobox = 'custom-combobox',
    Radio = 'radio',
    Separator = 'separator',
    Html = 'html',
    InputGroup = 'input-group',
    Segmented = 'segmented',
    Button = 'button',
    Template = 'template',
    FileSelect = 'file-select',
    RepeatSection = 'repeat-section',
    SectionHeader = 'section-header',
    PhoneInput = 'phone-input',
    ImageUpload = 'image-upload',
    PasswordIndicator = 'password-indicator',
}